/******************************************************************************************
Library Description : Adobe Analytics common functions called from all BFDL Properties.
Library Version : v1.0
Date Last Update : 10-07-2020
Update By : Bhuwanesh Pandey 
*******************************************************************************************/

// Initialise Digital Data Object.
var digitalData = digitalData || {};
digitalData.page = digitalData.page || {}; 				// Information of the page access by consumer
digitalData.product = digitalData.product || {}; 				// Information of product accees or purchesed by consumer.
digitalData.consumer = digitalData.consumer || {}; 				// Information about the consumer
digitalData.transaction = digitalData.transaction || {};				// Information of Order or application made by consumer.
digitalData.event = digitalData.event || {};				// ClickStream events made by consumer.
digitalData.system = digitalData.system || {};              //contain the information which provided by the system not fill by user.
digitalData.version = "v1.0";

// To be invoked on every page load. Initialises page section of data layer object.
function initiPageInfo(siteSection, siteSubSection, server, productId, productName, consumerType) {
    try {
        digitalData.page.siteSection = siteSection || "",
            digitalData.page.siteSubSection = siteSubSection || "",
            digitalData.page.server = server || "",
            digitalData.product.productId = productId || "",
            digitalData.consumer.type = consumerType || ""
        digitalData.product.productName = productName || "",
            digitalData.event.eventId = "pageInitialization"
    }
    catch (err) { }
}

//To be invoked when new Application is created.
function applicationCreated(applicantKey, mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, dataSource, processId, nextTaskKey, stagePercentage) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
            digitalData.consumer.dob = dob || "",
            digitalData.consumer.vehicleDetails = digitalData.consumer.vehicleDetails || {},
            digitalData.consumer.vehicleDetails.vehicleRegNo = vehicleRegNo || "",
            digitalData.consumer.vehicleDetails.vehicleRegId = vehicleRegId || "",
            digitalData.consumer.appQuoteCriteriaID = appQuoteCriteriaID || "",
            digitalData.consumer.processId = processId || "",
            digitalData.consumer.dataSource = dataSource || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "application Created",
            callStatellite("omnichannel-application-created-success")
    }
    catch (err) { }

}
//To be invoked when Application is Resume.
function applicationResumeStart(applicantKey, mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, vehicleMakeModel, vehicleVariant, applicantId, dataSource, processId, nextTaskKey, stagePercentage, varientCode, varientName) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.consumer.applicantId = applicantId || "",
            digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
            digitalData.consumer.dob = dob || "",
            digitalData.consumer.vehicleDetails = digitalData.consumer.vehicleDetails || {},
            digitalData.consumer.vehicleDetails.vehicleRegNo = vehicleRegNo || "",
            digitalData.consumer.vehicleDetails.vehicleRegId = vehicleRegId || "",
            digitalData.consumer.appQuoteCriteriaID = appQuoteCriteriaID || "",
            digitalData.consumer.vehicleDetails.vehicleMakeModel = vehicleMakeModel || "",
            digitalData.consumer.vehicleDetails.vehicleVariant = vehicleVariant || "",
            digitalData.transaction.cart = digitalData.transaction.cart || {},
            digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
            digitalData.transaction.cart.item.planDetail = digitalData.transaction.cart.item.planDetail || {},
            digitalData.transaction.cart.item.planDetail.varientCode = varientCode || "",
            digitalData.transaction.cart.item.planDetail.varientName = varientName || "",
            digitalData.consumer.processId = processId || "",
            digitalData.consumer.dataSource = dataSource || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "applicationResumeStart",
            callStatellite("omnichannel-application-resume-start")

    }
    catch (err) { }

}

//To be invoked when application resueme is completed.
function applicationResumeCompleted(applicantKey, mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, vehicleMakeModel, vehicleVariant, applicantId, dataSource, processId, nextTaskKey, stagePercentage, resumeWithOTP, varientCode, varientName) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.consumer.applicantId = applicantId || "",
            digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
            digitalData.consumer.dob = dob || "",
            digitalData.consumer.vehicleDetails = digitalData.consumer.vehicleDetails || {},
            digitalData.consumer.vehicleDetails.vehicleRegNo = vehicleRegNo || "",
            digitalData.consumer.vehicleDetails.vehicleRegId = vehicleRegId || "",
            digitalData.consumer.appQuoteCriteriaID = appQuoteCriteriaID || "",
            digitalData.consumer.vehicleDetails.vehicleMakeModel = vehicleMakeModel || "",
            digitalData.consumer.vehicleDetails.vehicleVariant = vehicleVariant || "",
            digitalData.transaction.cart = digitalData.transaction.cart || {},
            digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
            digitalData.transaction.cart.item.planDetail = digitalData.transaction.cart.item.planDetail || {},
            digitalData.transaction.cart.item.planDetail.varientCode = varientCode || "",
            digitalData.transaction.cart.item.planDetail.varientName = varientName || "",
            digitalData.consumer.processId = processId || "",
            digitalData.consumer.dataSource = dataSource || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventContext.resumeWithOTP = resumeWithOTP || "",
            digitalData.event.eventId = "applicationResumeComplete",
            callStatellite("omnichannel-application-resume-complete")

    }
    catch (err) { }

}

//When Vehicle Details get submitted.
function vehicleDetailsSubmit(applicantKey, quoteID, vehicleRegId, rtoLocation, vehicleMakeModel, vehicleVariant, vehicleFuelType, registrationMonthYear, ManufacturingYear, processId, nextTaskKey, stagePercentage) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.consumer.quoteID = quoteID || "",
            digitalData.consumer.vehicleDetails = digitalData.consumer.vehicleDetails || {},
            digitalData.consumer.vehicleDetails.vehicleRegId = vehicleRegId || "",
            digitalData.consumer.vehicleDetails.rtoLocation = rtoLocation || "",
            digitalData.consumer.vehicleDetails.vehicleMakeModel = vehicleMakeModel || "",
            digitalData.consumer.vehicleDetails.vehicleVariant = vehicleVariant || "",
            digitalData.consumer.vehicleDetails.vehicleFuelType = vehicleFuelType || "",
            digitalData.consumer.vehicleDetails.registrationMonthYear = registrationMonthYear || "",
            digitalData.consumer.vehicleDetails.ManufacturingYear = ManufacturingYear || "",
            digitalData.consumer.processId = processId || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "application vehicle details submit",
            callStatellite("omnichannel-motor-vehicle-details-submit")

    }
    catch (err) { }

}

//When Vehicle Details get submitted.
function previousPolicyDetailsSubmit(applicantKey, quoteID, prevPolicyDetId, prevPolicytype, prevPolicyClaimed, prevPolicyExpiryDate, processId, nextTaskKey, stagePercentage) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.consumer.quoteID = quoteID || "",
            digitalData.consumer.processId = processId || "",
            digitalData.consumer.dataSource = dataSource || "",
            digitalData.event.eventContext.prevPolicyDetId = prevPolicyDetId || "",
            digitalData.event.eventContext.prevPolicytype = prevPolicytype || "",
            digitalData.event.eventContext.prevPolicyClaimed = prevPolicyClaimed || "",
            digitalData.event.eventContext.prevPolicyExpiryDate = prevPolicyExpiryDate || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "previous policy details submit",
            callStatellite("omnichannel-motor-previous-policy-details-submit")
    }
    catch (err) { }

}

//Shows all lists of plans for customer to choose relevant plan
//please pass entire array of planlist in planList Variable
function planListingDisplayed(applicantKey, quoteID, quoteIds, planList, selectedAddOns, emiCardEligibility, processId, nextTaskKey, stagePercentage) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.consumer.quoteID = quoteID || "",
            digitalData.consumer.processId = processId || "",
            digitalData.consumer.quoteIds = quoteIds || "",
            digitalData.product.planList = planList || {},
            digitalData.product.selectedAddOns = selectedAddOns || {},
            digitalData.consumer.emiCardEligibility = emiCardEligibility || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "plan Listing Displayed",
            callStatellite("omnichannel-motor-plan-listing-displayed")
    }
    catch (err) { }

}

//when customer is editing Vehicle Details/Registration Number/Policy Coverage Details
function detailsEdit(applicantKey, detailsEditType, stageWhereEditInitiated, nextTaskKey, ) {

    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.event.eventContext.detailsEditType = detailsEditType || "",
        digitalData.event.eventContext.stageWhereEditInitiated = stageWhereEditInitiated || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.event.eventId = "details edit",
        callStatellite("omnichannel-details-edit")
}

/*
//when customer selects add ons
function selectAddOns(applicantKey,selectedAddOns,planList){
    digitalData.event.eventContext=digitalData.event.eventContext||{}, 
    digitalData.consumer.applicantKey=applicantKey||"", 
    digitalData.product.selectedAddOns=selectedAddOns||"",
    digitalData.product.planList=planList||{},
    digitalData.event.eventId="select add ons",
    callStatellite("omnichannel-select-add-ons") 
}

*/

// replacement for select add ons call
function refinement(applicationKey, quoteID, changeType, changePosition, planList, selectedAddOns) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.quoteID = quoteID || "",
            digitalData.event.eventContext.changeType = changeType || "",
            digitalData.event.eventContext.changePosition = changePosition || "",
            digitalData.product.planList = planList || {},
            digitalData.product.selectedAddOns = selectedAddOns || "",
            digitalData.event.eventId = "plan refinement",
            callStatellite("omnichannel-motor-plan-refinement")
    }
    catch (err) { }

}


//customer selects product and quote is created 

function quoteCreated(applicantKey, quoteID, varientName, varientCode, riderName, riderCode, principalName, planDescription, policyType, premiumAmount, tenure, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.transaction.cart = digitalData.transaction.cart || {},
        digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
        digitalData.transaction.cart.item.planDetail = digitalData.transaction.cart.item.planDetail || {},
        digitalData.transaction.cart.item.planDetail.varientCode = varientCode || "",
        digitalData.transaction.cart.item.planDetail.varientName = varientName || "",
        digitalData.transaction.cart.item.riderName = riderName || "",
        digitalData.transaction.cart.item.riderCode = riderCode || "",
        digitalData.event.eventContext.principalName = principalName || "",
        digitalData.event.eventContext.planDescription = planDescription || "",
        digitalData.event.eventContext.policyType = policyType || "",
        digitalData.transaction.cart.amount = digitalData.transaction.cart.amount || {},
        digitalData.transaction.cart.amount.premiumAmount = premiumAmount || "",
        digitalData.event.eventContext.tenure = tenure || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "policy quote created",
        callStatellite("omnichannel-policy-quote-created")


}

//More information capture on Your Policy Details page
function additonalPolicyDetailsCreated(applicantKey, quoteID, vehicleRegId, engineNo, chasisNo, previousPolicyNo, previousInsurerName, isCardFinanced, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.vehicleDetails = digitalData.consumer.vehicleDetails || {},
        digitalData.consumer.vehicleDetails.vehicleRegId = vehicleRegId || "",
        digitalData.consumer.vehicleDetails.engineNo = engineNo || "",
        digitalData.consumer.vehicleDetails.chasisNo = chasisNo || "",
        digitalData.event.eventContext.previousPolicyNo = previousPolicyNo || "",
        digitalData.event.eventContext.previousInsurerName = previousInsurerName || "",
        digitalData.event.eventContext.isCardFinanced = isCardFinanced || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "additonal policy details created",
        callStatellite("omnichannel-additonal-policy-details-created")
}

//Car owner detail capture page
function vehicleOwnerDetailsCreated(applicantKey, quoteID, firstName, lastName, emailID, dob, mobileNo, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
        digitalData.consumer.contact.emailID = emailID == undefined ? "" : window.btoa(emailID),
        digitalData.consumer.firstName = firstName || "",
        digitalData.consumer.lastName = lastName || "",
        digitalData.consumer.dob = dob || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "vehicle owner details created",
        callStatellite("omnichannel-vehicle-owner-details-created")
}
//Address detail capture page
function addressDetailsCreated(applicantKey, quoteID, addressId, addressType, address1, address2, pincode, city, state, tncFlag, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.addressId = addressId || "",
        digitalData.event.eventContext.addressType = addressType || "",
        digitalData.event.eventContext.address1 = address1 || "",
        digitalData.event.eventContext.address2 = address2 || "",
        digitalData.event.eventContext.pincode = pincode || "",
        digitalData.event.eventContext.city = city || "",
        digitalData.event.eventContext.state = state || "",
        digitalData.event.eventContext.tncFlag = tncFlag || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "address details created",
        callStatellite("omnichannel-address-details-created")
}

//Initiate payment       
function paymentStarted(applicantKey, quoteID, isPaymentStarted, paymentInstrument, systemPaymentId, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.isPaymentStarted = isPaymentStarted || "",
        digitalData.event.eventContext.paymentInstrument = paymentInstrument || "",
        digitalData.transaction.systemPaymentId = systemPaymentId || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "payment started",
        callStatellite("omnichannel-payment-started")
}

//Complete payment
function paymentCompleted(applicantKey, applicantId, quoteID, isPaymentCompleted, paymentInstrument, systemPaymentId, referenceNumber, orderId, paymentId, orderAmount, gstAmount, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.transaction.cart = digitalData.transaction.cart || {},
        digitalData.transaction.cart.amount = digitalData.transaction.cart.amount || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.applicantId = applicantId || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.isPaymentCompleted = isPaymentCompleted || "",
        digitalData.event.eventContext.paymentInstrument = paymentInstrument || "",
        digitalData.event.eventContext.referenceNumber = referenceNumber || "",
        digitalData.event.eventContext.paymentId = paymentId || "",
        digitalData.transaction.systemPaymentId = systemPaymentId || "",
        digitalData.transaction.cart.amount.orderAmount = orderAmount || "",
        digitalData.transaction.cart.amount.gstAmount = gstAmount || "",
        digitalData.transaction.orderId = orderId || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "payment completed",
        callStatellite("omnichannel-payment-completed")
}

// when payment is failed
function paymentFailed(applicantKey, quoteID, rejectReason, paymentInstrument, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.paymentInstrument = paymentInstrument || "",
        digitalData.event.eventContext.rejectReason = rejectReason || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "payment failed",
        callStatellite("omnichannel-payment-failed")

}

// issue policy start

function policyBookingStarted(applicantKey, quoteID, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "policy booking started",
        callStatellite("omnichannel-policy-booking-started")
}

//issue policy complete
function policyIssued(applicantKey, quoteID, policyStatus, quoteItemId, policyNo, policyType, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.policyStatus = policyStatus || "",
        digitalData.consumer.quoteItemId = quoteItemId,
        digitalData.event.eventContext.policyType = policyType || "",
        digitalData.consumer.policyNo = policyNo || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "policy issued",
        callStatellite("omnichannel-policy-issued")
}

//when back is pressed
function backButton(applicantKey, stageWhereBackInitiated, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.event.eventContext.stageWhereBackInitiated = stageWhereBackInitiated || ""
    digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "back button click",
        callStatellite("omnichannel-back-button-click")
}

//when customer confirms about expired policy
function nonSTPJourneyInitiate(mobileNo, dob, vehicleRegNo) {
    digitalData.consumer.contact = digitalData.consumer.contact || {},
        digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
        digitalData.consumer.vehicleDetails = digitalData.consumer.vehicleDetails || {},
        digitalData.consumer.vehicleDetails.vehicleRegNo = vehicleRegNo || "",
        digitalData.consumer.dob = dob || "",
        digitalData.event.eventId = "non STP Journey Initiate",
        callStatellite("omnichannel-motor-non-STP-Journey-Initiate")

}
//click on Explore more products
function exploreMoreProducts(applicantKey, quoteID, currentStage, destinationURL) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.system.currentStage = currentStage || "",
        digitalData.event.eventContext.destinationURL = destinationURL || "",
        digitalData.event.eventId = "explore More Products",
        callStatellite("omnichannel-explore-more-products")
}

//	click on cross sell products
function crossellProducts(applicantKey, quoteID, currentStage, productCode, productName, bannerName, bannerPosition, bannerDiscription, destinationURL) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.system.currentStage = currentStage || "",
        digitalData.event.eventContext.crosSell = digitalData.event.eventContext.crosSell || {},
        digitalData.event.eventContext.crosSell.productCode = productCode || "",
        digitalData.event.eventContext.crosSell.productName = productName || "",
        digitalData.event.eventContext.bannerName = bannerName || "",
        digitalData.event.eventContext.bannerPosition = bannerPosition || "",
        digitalData.event.eventContext.bannerDiscription = bannerDiscription || "",
        digitalData.event.eventContext.destinationURL = destinationURL || "",
        digitalData.event.eventId = "cros sell Products",
        callStatellite("omnichannel-cros-sell-product")
}

// To be invoked of an API Failure. 
function triggerAPIFailure(errorCode, errorName, apiName) {
    try {
        digitalData.system.error = digitalData.system.error || {},
            digitalData.system.error.errorCode = errorCode || "",
            digitalData.system.error.errorName = errorName || "",
            digitalData.system.error.apiName = apiName || "",
            callStatellite("omnichannel-api-failure")
    }
    catch (err) { }
}

// common function for _satellite
function callStatellite(eventName) {
    try { _satellite.track(eventName); } catch (err) { }
}

